import { Fragment, lazy, Suspense } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import AppShell from "../components/ui/AppShell";
import useAuth from "../hooks/useAuth";

const ConciliacaoNotaFiscal = lazy(() => import("../pages/ConciliacaoNota"));
const EntradaManualProduto = lazy(() =>
  import("../pages/EntradaManualProduto"),
);
const FrenteCaixa = lazy(() => import("../pages/FrenteCaixa"));
const HistoricoMovimentacoesProduto = lazy(() =>
  import("../pages/HistoricoMovimentacoesProduto"),
);
const Home = lazy(() => import("../pages/Home"));
const ProdutoDetalhe = lazy(() => import("../pages/ProdutoDetalhe"));
const RelDisponibilidadeCaixa = lazy(() =>
  import("../pages/relatorios/disponibilidadeEstoque"),
);
const SaidaManualProduto = lazy(() => import("../pages/SaidaManualProduto"));
const Signin = lazy(() => import("../pages/Signin"));
const UploadNotaFiscal = lazy(() => import("../pages/UploadNotaFiscal"));
const FluxoCaixa = lazy(() => import("../pages/FluxoCaixa"));
const FechamentoDiario = lazy(() => import("../pages/FechamentoDiario"));
const ConversorZpl = lazy(() => import("../pages/ConversorZpl"));
const AdmUsuarios = lazy(() => import("../pages/AdmUsuarios"));
const AuditoriaNotasFiscais = lazy(() =>
  import("../pages/AuditoriaNotasFiscais"),
);
const GerenciamentoLojasTokens = lazy(() =>
  import("../pages/GerenciamentoLojasTokens"),
);

const Private = ({ Item }) => {
  const { authenticated, loading, permissoes } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const path = location.pathname.replace("/", ""); // remove a barra inicial
  let autorizado = permissoes.some((p) => p.name === path);
  const produtoDetalhe = path.includes("produto") ? true : false;

  autorizado = autorizado || produtoDetalhe;

  if (loading) {
    return <h1>Carregando...</h1>;
  }

  if (authenticated && !autorizado) return navigate("home");
  return authenticated && autorizado > 0 ? <Item /> : <Signin />;
};

const FrenteCaixaLoja = () => {
  return <FrenteCaixa origem="loja" />;
};

// Wrapper para Frente Caixa Galpão
const FrenteCaixaGalpao = () => {
  return <FrenteCaixa origem="galpao" />;
};

const RoutesApp = () => {
  return (
    <BrowserRouter>
      <Fragment>
        <Suspense fallback={<h1>Carregando...</h1>}>
          <Routes>
            <Route path="/" element={<Private Item={AppShell} />}>
              <Route exact path="/home" element={<Private Item={Home} />} />
              <Route
                path="/produto/:id"
                element={<Private Item={ProdutoDetalhe} />}
              />
              <Route
                path="/uploadNFE"
                element={<Private Item={UploadNotaFiscal} />}
              />
              <Route
                path="/conciliacao"
                element={<Private Item={ConciliacaoNotaFiscal} />}
              />
              <Route
                path="/entradaManual"
                element={<Private Item={EntradaManualProduto} />}
              />
              <Route
                path="/saidaManual"
                element={<Private Item={SaidaManualProduto} />}
              />
              <Route
                path="/frenteCaixaLoja"
                element={<Private Item={FrenteCaixaLoja} />}
              />
              <Route
                path="/frenteCaixaGalpao"
                element={<Private Item={FrenteCaixaGalpao} />}
              />
              <Route
                path="/relatorioDisponibilidade"
                element={<Private Item={RelDisponibilidadeCaixa} />}
              />
              <Route
                path="/relHistMovimentacaoProd"
                element={<Private Item={HistoricoMovimentacoesProduto} />}
              />

              <Route
                path="/fluxoCaixa"
                element={<Private Item={FluxoCaixa} />}
              />

              <Route
                path="/fechamentoDiario"
                element={<Private Item={FechamentoDiario} />}
              />

              <Route
                path="/conversorZpl"
                element={<Private Item={ConversorZpl} />}
              />

              <Route
                path="/admUsuarios"
                element={<Private Item={AdmUsuarios} />}
              />

              <Route
                path="/auditoriaNotasFiscais"
                element={<Private Item={AuditoriaNotasFiscais} />}
              />

              <Route
                path="/gerenciamentoLojasTokens"
                element={<Private Item={GerenciamentoLojasTokens} />}
              />
            </Route>
            <Route path="*" element={<Signin />} />
            <Route path="/signin" element={<Signin />} />
          </Routes>
        </Suspense>
      </Fragment>
    </BrowserRouter>
  );
};

export default RoutesApp;
